import React from 'react'

const Testimonials: React.FC = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  const testimonials = [
    {
      quote: "Singh's Best Buy helped me secure a luxury apartment in IREO Corridors at pre-launch prices. Their exclusive access and market insights saved me ₹15 lakhs. The property has already appreciated 30% in 2 years.",
      name: "Rajesh Kumar",
      title: "Tech Entrepreneur",
      location: "Gurgaon"
    },
    {
      quote: "As an NRI investor, I needed reliable partners for property investment. Their thorough due diligence and developer verification gave me confidence. My investment in Landmark SkyVue is performing exceptionally well.",
      name: "Priya Sharma",
      title: "Investment Banker",
      location: "Dubai"
    },
    {
      quote: "The team's expertise in plotted developments is unmatched. They guided me through IREO Savannah investment, and the location near Sohna Road has shown tremendous growth potential. Highly recommended for serious investors.",
      name: "Amit Gupta",
      title: "Business Owner",
      location: "Delhi"
    },
    {
      quote: "Their research-driven approach and exclusive project access made all the difference. I invested in IREO Pride Park based on their recommendation, and the returns have exceeded expectations. True professionals.",
      name: "Dr. Neha Singh",
      title: "Medical Professional",
      location: "Gurgaon"
    }
  ]

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-neutral-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center max-w-7xl mx-auto">
          {/* Image Column */}
          <div className="relative order-2 lg:order-1 lg:col-span-6">
            <div className="relative z-10 rounded-[2rem] overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-[5/4] w-full mx-auto">
              <img
                src="/working/3.JPG"
                alt="Happy Clients"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-primary/20 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-secondary/20 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2 lg:col-span-6">
            <div className="mb-12">
              <h2 className="text-4xl md:text-5xl font-bold font-bricolage mb-4 text-neutral-900">
                What Our <span className="text-primary">Clients Say</span>
              </h2>
              <p className="text-lg text-neutral-600">
                Real stories from satisfied investors who trusted us with their real estate journey.
              </p>
            </div>

            <div className="relative">
              {/* Quote Icon */}
              <div className="absolute -top-10 -left-6 text-primary/20">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 8.44772 14.017 9V11C14.017 11.5523 13.5693 12 13.017 12H12.017V5H22.017V15C22.017 18.3137 19.3307 21 16.017 21H14.017ZM5.01697 21L5.01697 18C5.01697 16.8954 5.9124 16 7.01697 16H10.017C10.5693 16 11.017 15.5523 11.017 15V9C11.017 8.44772 10.5693 8 10.017 8H6.01697C5.46468 8 5.01697 8.44772 5.01697 9V11C5.01697 11.5523 4.56925 12 4.01697 12H3.01697V5H13.017V15C13.017 18.3137 10.3307 21 7.01697 21H5.01697Z" />
                </svg>
              </div>

              {/* Carousel Content */}
              <div className="relative z-10 bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-neutral-100 min-h-[300px] flex flex-col justify-between transition-all duration-500">
                <p className="text-xl md:text-2xl font-medium text-neutral-800 leading-relaxed mb-8 font-dm-sans italic">
                  "{testimonials[activeIndex].quote}"
                </p>

                <div className="flex items-center justify-between border-t border-neutral-100 pt-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-2xl">
                      {testimonials[activeIndex].name[0]}
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-neutral-900">{testimonials[activeIndex].name}</h4>
                      <p className="text-sm text-neutral-500">{testimonials[activeIndex].title}, {testimonials[activeIndex].location}</p>
                    </div>
                  </div>

                  {/* Navigation Buttons */}
                  <div className="flex gap-3">
                    <button
                      onClick={prevTestimonial}
                      className="w-12 h-12 flex items-center justify-center rounded-full border border-neutral-200 text-neutral-600 hover:bg-neutral-900 hover:text-white hover:border-neutral-900 transition-all duration-300"
                      aria-label="Previous testimonial"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <button
                      onClick={nextTestimonial}
                      className="w-12 h-12 flex items-center justify-center rounded-full bg-neutral-900 text-white border border-neutral-900 hover:bg-primary hover:border-primary transition-all duration-300 shadow-lg hover:shadow-primary/30"
                      aria-label="Next testimonial"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Indicators */}
              <div className="flex justify-center mt-8 gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`h-2 rounded-full transition-all duration-300 ${index === activeIndex ? 'w-8 bg-primary' : 'w-2 bg-neutral-300 hover:bg-neutral-400'
                      }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
